import { Pipe, PipeTransform } from '@angular/core';
import { DataTypes } from 'src/app/_shared/services/advanced-rule/advanced-rule.service';
import { arrayEmpty } from 'src/app/utils/array.utils';
import { MoteurCritereDto } from 'src/graphql/generated-types';

@Pipe({
    name: 'isNumberCriterion',
    standalone: false
})
export class IsNumberCriterionPipe implements PipeTransform {

    transform(criterionId: number, criteriaList: MoteurCritereDto[]): boolean {
        if (arrayEmpty(criteriaList)) {
            return false;
        }

        const criterion = criteriaList.find(({Id}) => Id === criterionId);
        return criterion?.TypeDonnee?.Code === DataTypes.Number;
    }

}
